import { render, staticRenderFns } from "./add-sub.vue?vue&type=template&id=23206df7&scoped=true&"
import script from "./add-sub.vue?vue&type=script&lang=ts&"
export * from "./add-sub.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23206df7",
  null
  
)

export default component.exports